import React from "react";
import TextField from "../forms/TextField";
import { defineMessages, FormattedMessage, injectIntl, intlShape } from "react-intl";
import Button from "../Button";
import { connect } from "react-redux";
import { FORGOT_PASSWORD, onEmailFieldChange, submitForgotPassword } from "./forgotPassword-redux";
import PasswordPanel from "./passwordPanel";

class ForgotPasswordContainer extends React.Component {
    constructor(props) {
        super(props);
        this.onClickHandler = this.onClickHandler.bind(this);
        this.onEnterHandler = this.onEnterHandler.bind(this);
    }

    onClickHandler(event) {
        event.preventDefault();
        this.props.submitForgotPassword(this.props.email);
    }

    onEnterHandler() {
        this.props.submitForgotPassword(this.props.email);
    }

    render() {
        const { formatMessage } = this.props.intl;

        const formFields = defineMessages({
            emailField: {
                id: "forgotPassword.emailLabel",
                defaultMessage: "Email",
            },
            emailPlaceholder: {
                id: "forgotPassword.emailPlaceholder",
                defaultMessage: "Enter your email to reset password",
            },
            submitBtn: {
                id: "forgotPassword.submitBtn",
                defaultMessage: "Get Reset Link",
            },
            successMessage: {
                id: "forgotPassword.success",
                defaultMessage: "Reset password email sent.",
            },
            header: {
                id: "forgotPassword.header",
                defaultMessage: "Forgot Password",
            },
        });

        let successView = (
            <FormattedMessage
                id={formFields.successMessage.id}
                defaultMessage={formFields.successMessage.defaultMessage}
                values={{
                    email: this.props.email,
                    resendLink: (
                        <a href="#" onClick={this.onClickHandler}>
                            <FormattedMessage id="links.clickHere" defaultMessage="click here" />
                        </a>
                    ),
                }}
            />
        );

        let formView = (
            <div>
                <TextField
                    onEnter={this.onEnterHandler}
                    onChange={this.props.onEmailFieldChange}
                    type={"text"}
                    placeholder={formatMessage(formFields.emailPlaceholder)}
                    autoFocus
                    tabIndex={1}
                    id={"email"}
                    name={"email"}
                />
                <div className="button">
                    <Button onClick={this.onClickHandler} tabIndex={3}>
                        {formatMessage(formFields.submitBtn)}
                    </Button>
                </div>
            </div>
        );

        return (
            <PasswordPanel
                header={formatMessage(formFields.header)}
                successView={successView}
                formView={formView}
                errorMessageId={this.props.errorMessageId}
                isLoading={this.props.isLoading}
                showSuccessView={this.props.showSuccessView}
                passwordErrors={[]}
            />
        );
    }
}

const mapStateToProps = state => {
    //combineReducers put states of each reducers in a submap, we test for that here
    let forgotPasswordState = state;
    if (state.hasOwnProperty(FORGOT_PASSWORD)) {
        forgotPasswordState = state[FORGOT_PASSWORD];
    }
    return {
        isLoading: forgotPasswordState.isLoading,
        errorMessageId: forgotPasswordState.errorMessageId,
        showSuccessView: forgotPasswordState.showSuccessView,
        email: forgotPasswordState.email,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch,
        onEmailFieldChange: event => {
            event.preventDefault();
            dispatch(onEmailFieldChange(event.target.value));
        },
        submitForgotPassword: email => {
            dispatch(submitForgotPassword(email));
        },
    };
};

ForgotPasswordContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(ForgotPasswordContainer);

ForgotPasswordContainer.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ForgotPasswordContainer);
